(function () {
  var DESKTOP_QUERY = '(min-width: 750px)';
  var SCRIPT_SOURCE = document.currentScript && document.currentScript.src;

  function ensureStyles() {
    if (document.querySelector('link[href*="gang-size-rail.css"], style[data-fp-size-selector-styles]')) return;
    if (!SCRIPT_SOURCE) return;

    var stylesheet = document.createElement('link');
    stylesheet.rel = 'stylesheet';
    stylesheet.href = SCRIPT_SOURCE.split('?')[0].replace(/gang-size-rail\.js$/, 'gang-size-rail.css');
    stylesheet.dataset.fpSizeSelectorStyles = 'true';
    document.head.appendChild(stylesheet);
  }

  ensureStyles();

  function isGangPage() {
    return document.documentElement.classList.contains('fp-gang-upload-page-static') ||
      document.documentElement.classList.contains('fp-gang-builder-page');
  }

  function parseSize(value) {
    var numbers = String(value || '').match(/\d+(?:\.\d+)?/g) || [];
    var width = Number(numbers[0] || 22);
    var length = Number(numbers[numbers.length - 1] || 12);
    return {
      width: width,
      length: length,
      dimensions: width + ' × ' + length + ' IN',
      lengthText: length + ' IN LENGTH'
    };
  }

  function formatMoney(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(Number(cents || 0) / 100);
    } catch (error) {
      return '$' + (Number(cents || 0) / 100).toFixed(2);
    }
  }

  function getOptionData(input, label, variantPrice) {
    var parsed = parseSize(input.value);
    var priceNode = label.querySelector('small');
    return {
      input: input,
      label: label,
      lengthText: parsed.lengthText,
      dimensions: parsed.dimensions,
      price: priceNode && priceNode.textContent.trim() ? priceNode.textContent.trim() : formatMoney(variantPrice)
    };
  }

  function enhanceLabel(option) {
    if (option.label.dataset.fpSizeEnhanced === 'true') return;
    option.label.dataset.fpSizeEnhanced = 'true';
    option.label.innerHTML =
      '<span class="fp-size-option__length">' + option.lengthText + '</span>' +
      '<span class="fp-size-option__dimensions">' + option.dimensions + '</span>' +
      '<span class="fp-size-option__price">' + option.price + '</span>' +
      '<span class="fp-size-option__check" aria-hidden="true">✓</span>';
  }

  function selectedOption(options) {
    return options.find(function (option) { return option.input.checked; }) || options[0];
  }

  function updateSummary(picker, options) {
    var option = selectedOption(options);
    updateSummaryForOption(picker, option);
  }

  function updateSummaryForOption(picker, option) {
    if (!option) return;
    var lengthNode = picker.querySelector('.fp-size-dropdown__length');
    var dimensionsNode = picker.querySelector('.fp-size-dropdown__dimensions');
    var priceNode = picker.querySelector('.fp-size-dropdown__price');
    var mobileLength = picker.querySelector('.fp-size-mobile__summary strong');
    var mobilePrice = picker.querySelector('.fp-size-mobile__summary span');
    if (lengthNode) lengthNode.textContent = option.lengthText;
    if (dimensionsNode) dimensionsNode.textContent = option.dimensions;
    if (priceNode) priceNode.textContent = option.price;
    if (mobileLength) mobileLength.textContent = option.lengthText;
    if (mobilePrice) mobilePrice.textContent = option.price;
  }

  function centerSelected(rail, options, behavior) {
    if (window.matchMedia(DESKTOP_QUERY).matches) return;
    var option = selectedOption(options);
    if (!option) return;
    var railRect = rail.getBoundingClientRect();
    var labelRect = option.label.getBoundingClientRect();
    var labelTopInRail = rail.scrollTop + labelRect.top - railRect.top;
    var top = labelTopInRail - (rail.clientHeight - labelRect.height) / 2;
    rail.scrollTo({ top: Math.max(0, top), behavior: behavior || 'auto' });
  }

  function mountSelector(picker) {
    if (!picker || picker.dataset.fpSelectorV2 === 'true') return;
    var rail = picker.querySelector('.product-form__input');
    if (!rail) return;
    var inputs = Array.prototype.slice.call(rail.querySelectorAll('input[type="radio"]'));
    if (!inputs.length) return;

    var variants = [];
    var variantJson = picker.querySelector('script[type="application/json"]');
    if (variantJson) {
      try { variants = JSON.parse(variantJson.textContent || '[]'); }
      catch (error) { variants = []; }
    }

    var options = inputs.map(function (input) {
      var label = rail.querySelector('label[for="' + CSS.escape(input.id) + '"]');
      var variant = variants.find(function (item) {
        return item && item.options && String(item.options[0]) === String(input.value);
      });
      return label ? getOptionData(input, label, variant && variant.price) : null;
    }).filter(Boolean);
    if (!options.length) return;

    picker.dataset.fpSelectorV2 = 'true';
    picker.dataset.fpRailMounted = 'true';
    picker.classList.add('fp-gang-step-two');
    rail.classList.add('fp-size-rail');
    options.forEach(enhanceLabel);

    var oldControls = picker.querySelector('.fp-size-rail__controls');
    if (oldControls) oldControls.remove();

    var controls = document.createElement('div');
    controls.className = 'fp-size-rail__controls';
    controls.innerHTML =
      '<span class="fp-size-selector__helper">All sheets are 22 in wide</span>' +
      '<button type="button" class="fp-size-dropdown__trigger" aria-expanded="false">' +
        '<span class="fp-size-dropdown__selection">' +
          '<span class="fp-size-dropdown__length"></span>' +
          '<span class="fp-size-dropdown__dimensions"></span>' +
        '</span>' +
        '<span class="fp-size-dropdown__price"></span>' +
        '<span class="fp-size-dropdown__chevron" aria-hidden="true"></span>' +
      '</button>' +
      '<div class="fp-size-mobile__summary" aria-live="polite"><strong></strong><span></span></div>';
    picker.insertBefore(controls, rail);

    var trigger = controls.querySelector('.fp-size-dropdown__trigger');
    trigger.addEventListener('click', function () {
      var open = !picker.classList.contains('is-open');
      picker.classList.toggle('is-open', open);
      trigger.setAttribute('aria-expanded', String(open));
      if (open) {
        var selected = selectedOption(options);
        if (selected) selected.label.scrollIntoView({ block: 'nearest' });
      }
    });

    function closeDropdown() {
      picker.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
    }

    document.addEventListener('click', function (event) {
      if (window.matchMedia(DESKTOP_QUERY).matches && !picker.contains(event.target)) closeDropdown();
    });

    picker.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeDropdown();
        trigger.focus();
      }
    });

    var settleTimer = 0;
    var scrollFrame = 0;
    var previewOption = null;
    var touchActive = false;
    var touchMoved = false;
    var touchStartY = 0;
    var touchStartScrollTop = 0;
    var gestureNeedsCommit = false;
    var waitForScrollEnd = false;
    var supportsScrollEnd = 'onscrollend' in rail;
    var TOUCH_MOVE_THRESHOLD = 10;
    var SCROLL_SETTLE_DELAY = 160;
    var CANCELLED_TOUCH_SETTLE_DELAY = 320;

    function clearPreviewState() {
      rail.classList.remove('is-user-scrolling');
      options.forEach(function (item) { item.label.classList.remove('is-scroll-active'); });
      previewOption = null;
    }

    function cancelWheelCommit() {
      window.clearTimeout(settleTimer);
      settleTimer = 0;
      if (scrollFrame) {
        window.cancelAnimationFrame(scrollFrame);
        scrollFrame = 0;
      }
      gestureNeedsCommit = false;
      waitForScrollEnd = false;
      touchMoved = false;
      clearPreviewState();
    }

    options.forEach(function (option) {
      option.input.addEventListener('change', function () {
        // A direct tap/click is authoritative. Cancel any delayed scroll commit
        // so iOS momentum or snap correction cannot replace that selection.
        cancelWheelCommit();
        updateSummary(picker, options);
        if (window.matchMedia(DESKTOP_QUERY).matches) closeDropdown();
        else window.requestAnimationFrame(function () { centerSelected(rail, options, 'auto'); });
      });
    });

    function scrollSizeRailWithWheel(event) {
      var isDesktop = window.matchMedia(DESKTOP_QUERY).matches;
      if (isDesktop && !picker.classList.contains('is-open')) return;
      if (event.ctrlKey) return;

      var verticalDelta = Number(event.deltaY || 0);
      var horizontalDelta = Number(event.deltaX || 0);
      var delta = Math.abs(verticalDelta) >= Math.abs(horizontalDelta) ? verticalDelta : horizontalDelta;
      if (!delta) return;
      if (event.deltaMode === 1) delta *= 18;
      if (event.deltaMode === 2) delta *= Math.max(rail.clientHeight, 1);

      var maxScroll = Math.max(0, rail.scrollHeight - rail.clientHeight);
      if (!maxScroll) return;

      var currentScroll = rail.scrollTop;
      var nextScroll = Math.max(0, Math.min(maxScroll, currentScroll + delta));

      // At either edge, hand the wheel back to the page instead of trapping it.
      if (nextScroll === currentScroll) return;

      if (!isDesktop) gestureNeedsCommit = true;
      event.preventDefault();
      event.stopPropagation();
      rail.scrollTop = nextScroll;
    }

    // Capture on the whole selector so the wheel works over every part of the
    // open dropdown, including its labels, gaps, scrollbar, and summary edge.
    picker.addEventListener('wheel', scrollSizeRailWithWheel, { passive: false, capture: true });

    function nearestOption() {
      var railRect = rail.getBoundingClientRect();
      var center = rail.scrollTop + rail.clientHeight / 2;
      return options.reduce(function (best, option) {
        var labelRect = option.label.getBoundingClientRect();
        var labelTopInRail = rail.scrollTop + labelRect.top - railRect.top;
        var optionCenter = labelTopInRail + labelRect.height / 2;
        var distance = Math.abs(optionCenter - center);
        return !best || distance < best.distance ? { option: option, distance: distance } : best;
      }, null);
    }

    function previewNearest() {
      scrollFrame = 0;
      var nearest = nearestOption();
      if (!nearest) return;

      rail.classList.add('is-user-scrolling');
      if (previewOption !== nearest.option) {
        options.forEach(function (option) {
          option.label.classList.toggle('is-scroll-active', option === nearest.option);
        });
        previewOption = nearest.option;
        updateSummaryForOption(picker, nearest.option);
      }
    }

    function commitNearest() {
      if (window.matchMedia(DESKTOP_QUERY).matches || touchActive || !gestureNeedsCommit) return;

      window.clearTimeout(settleTimer);
      settleTimer = 0;
      if (scrollFrame) {
        window.cancelAnimationFrame(scrollFrame);
        scrollFrame = 0;
      }

      var nearest = nearestOption();
      var option = nearest && nearest.option;
      gestureNeedsCommit = false;
      waitForScrollEnd = false;
      if (option && !option.input.checked) option.input.click();
      else updateSummary(picker, options);

      clearPreviewState();
    }

    function scheduleCommit(delay) {
      window.clearTimeout(settleTimer);
      settleTimer = 0;
      if (touchActive || !gestureNeedsCommit) return;
      settleTimer = window.setTimeout(commitNearest, delay || SCROLL_SETTLE_DELAY);
    }

    rail.addEventListener('scroll', function () {
      if (window.matchMedia(DESKTOP_QUERY).matches) return;
      if (!touchMoved && !gestureNeedsCommit) return;
      if (!scrollFrame) scrollFrame = window.requestAnimationFrame(previewNearest);
      window.clearTimeout(settleTimer);
      settleTimer = 0;
      if (!touchActive && !waitForScrollEnd) scheduleCommit();
    }, { passive: true });

    rail.addEventListener('touchstart', function (event) {
      if (window.matchMedia(DESKTOP_QUERY).matches || !event.touches || !event.touches.length) return;
      cancelWheelCommit();
      touchActive = true;
      touchStartY = event.touches[0].clientY;
      touchStartScrollTop = rail.scrollTop;
    }, { passive: true });

    rail.addEventListener('touchmove', function (event) {
      if (!touchActive || !event.touches || !event.touches.length) return;
      var movedByTouch = Math.abs(event.touches[0].clientY - touchStartY);
      var movedByRail = Math.abs(rail.scrollTop - touchStartScrollTop);
      if (movedByTouch >= TOUCH_MOVE_THRESHOLD || movedByRail >= TOUCH_MOVE_THRESHOLD) {
        touchMoved = true;
        gestureNeedsCommit = true;
      }
    }, { passive: true });

    function finishTouch() {
      if (!touchActive) return;
      if (Math.abs(rail.scrollTop - touchStartScrollTop) >= TOUCH_MOVE_THRESHOLD) {
        touchMoved = true;
        gestureNeedsCommit = true;
      }
      touchActive = false;
      waitForScrollEnd = false;
      if (touchMoved) scheduleCommit();
      else cancelWheelCommit();
    }

    rail.addEventListener('touchend', finishTouch, { passive: true });
    rail.addEventListener('touchcancel', function () {
      if (!touchActive) return;
      var railMoved = Math.abs(rail.scrollTop - touchStartScrollTop) >= TOUCH_MOVE_THRESHOLD;
      touchActive = false;
      if (!railMoved) {
        cancelWheelCommit();
        return;
      }

      touchMoved = true;
      gestureNeedsCommit = true;
      // A native browser may cancel page touch events when it takes ownership
      // of scrolling. If scrollend exists, wait for that definitive signal.
      // Older browsers get a deliberately slower fallback.
      waitForScrollEnd = supportsScrollEnd;
      if (!supportsScrollEnd) scheduleCommit(CANCELLED_TOUCH_SETTLE_DELAY);
    }, { passive: true });

    if (supportsScrollEnd) {
      rail.addEventListener('scrollend', function () {
        if (!touchActive && gestureNeedsCommit) {
          waitForScrollEnd = false;
          commitNearest();
        }
      }, { passive: true });
    }

    var media = window.matchMedia(DESKTOP_QUERY);
    function syncMode() {
      cancelWheelCommit();
      touchActive = false;
      if (media.matches) {
        closeDropdown();
        rail.scrollTop = 0;
      } else {
        picker.classList.remove('is-open');
        window.requestAnimationFrame(function () { centerSelected(rail, options, 'auto'); });
      }
      updateSummary(picker, options);
    }
    if (media.addEventListener) media.addEventListener('change', syncMode);
    else media.addListener(syncMode);

    updateSummary(picker, options);
    window.requestAnimationFrame(syncMode);
  }

  function mountAll() {
    if (!isGangPage()) return;
    document.querySelectorAll('variant-radios, variant-selects').forEach(mountSelector);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountAll);
  else mountAll();
  window.addEventListener('load', mountAll);
  window.setTimeout(mountAll, 350);
  window.setTimeout(mountAll, 1200);
  new MutationObserver(mountAll).observe(document.documentElement, { childList: true, subtree: true });
})();
